var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolarBattery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_15",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20.05,
    cy: 30.91,
    r: 1.43,
    fill: "#004571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6,24.68c1.71-1.54,3.98-2.47,6.45-2.47s4.74,.93,6.45,2.47",
    fill: "none",
    stroke: "#004571",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,28.59c.7-.55,1.58-.86,2.55-.86s1.85,.32,2.55,.86",
    fill: "none",
    stroke: "#004571",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.53,26.66c-1.21-1.03-2.78-1.65-4.48-1.65s-3.27,.62-4.48,1.65",
    fill: "none",
    stroke: "#004571",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6,24.68c1.71-1.54,3.98-2.47,6.45-2.47s4.74,.93,6.45,2.47",
    fill: "none",
    stroke: "#004571",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 5.33,
    y1: 19.03,
    x2: 2.84,
    y2: 19.03,
    fill: "none",
    stroke: "#004571",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.49,
    y1: 8.59,
    x2: 7.73,
    y2: 6.83,
    fill: "none",
    stroke: "#004571",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.81,
    y1: 4.16,
    x2: 19.81,
    y2: 1.67,
    fill: "none",
    stroke: "#004571",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.24,
    y1: 8.32,
    x2: 32,
    y2: 6.56,
    fill: "none",
    stroke: "#004571",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.67,
    y1: 18.64,
    x2: 37.16,
    y2: 18.64,
    fill: "none",
    stroke: "#004571",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 9.94,
    y1: 37.5,
    x2: 30.4,
    y2: 37.5,
    fill: "none",
    stroke: "#004571",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.71,17.66s1.09-1.55,3.2-1.55c2.3,0,3.48,1.55,3.48,1.55",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#004571",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.13,12.33c0-2.79,2.26-5.04,5.04-5.04s5.04,2.26,5.04,5.04",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#004571",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.65,37.5l-3.81-11.38c-1.11-3.33-.61-7.04,1.5-9.84,.62-.82,1.3-1.57,2.04-2.1,3.66-2.63,7.79-2.53,7.79-2.53,0,0,4.35-.16,9.02,3.83,.29,.25,.57,.56,.82,.9,1.84,2.46,2.18,5.75,1.18,8.66l-4.28,12.47",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#004571",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarBattery);
export default __webpack_public_path__ + "static/media/solar_battery.21323783471f98c5b2f3b2cdabd72685.svg";
export { ForwardRef as ReactComponent };